import React from 'react';
import { Link } from 'react-router-dom';
const footerData = [{
  title: 'Platform',
  links: [{
    label: 'Platform Overview',
    to: '/platform'
  }, {
    label: 'Breach and Attack Simulation',
    to: '/breach-and-attack-simulation'
  }, {
    label: 'Exposure Validation',
    to: '/platform/exposure-validation'
  }, {
    label: 'Automated Penetration Testing',
    to: '/platform/automated-penetration-testing'
  }, {
    label: 'Picus Swarm',
    to: '/platform/picus-swarm'
  }, {
    label: 'Security Control Validation',
    to: '/security-control-validation'
  }, {
    label: 'Attack Surface Validation',
    to: '/attack-surface-validation'
  }, {
    label: 'Cloud Security Validation',
    to: '/cloud-security-validation'
  }, {
    label: 'Attack Path Validation',
    to: '/attack-path-validation'
  }, {
    label: 'Detection Rule Validation',
    to: '/detection-rule-validation'
  }]
}, {
  title: 'Use Cases',
  links: [{
    label: 'Emerging Threat Response',
    to: '/use-cases/emerging-threat-response'
  }, {
    label: 'Validate Security Controls',
    to: '/use-cases/validate-security-controls'
  }, {
    label: 'Validate Detection Rules',
    to: '/use-cases/validate-detection-rules'
  }, {
    label: 'Prioritize Real Exposure',
    to: '/use-cases/prioritize-real-exposure'
  }, {
    label: 'Reduce Manual Triage',
    to: '/use-cases/reduce-manual-triage'
  }, {
    label: 'Accelerate Remediation',
    to: '/use-cases/accelerate-remediation'
  }, {
    label: 'AI Security Validation',
    to: '/use-cases/ai-security-validation'
  }, {
    label: 'Prove Readiness',
    to: '/use-cases/prove-readiness'
  }]
}, {
  title: 'Industries',
  links: [{
    label: 'Financial Services',
    to: '/industries/financial-services'
  }, {
    label: 'Healthcare',
    to: '/industries/healthcare'
  }, {
    label: 'IT / OT',
    to: '/industries/it-ot'
  }, {
    label: 'Critical Infrastructure',
    to: '/industries/critical-infrastructure'
  }, {
    label: 'Manufacturing',
    to: '/industries/manufacturing'
  }, {
    label: 'Retail / eCommerce',
    to: '/industries/retail-ecommerce'
  }, {
    label: 'Public Sector',
    to: '/industries/public-sector'
  }, {
    label: 'Technology / SaaS',
    to: '/industries/technology-saas'
  }]
}, {
  title: 'Frameworks & Compliance',
  links: [{
    label: 'CTEM',
    to: '/frameworks-and-compliance/ctem'
  }, {
    label: 'MITRE ATT&CK',
    to: '/frameworks-and-compliance/mitre-attack'
  }, {
    label: 'DORA',
    to: '/frameworks-and-compliance/dora'
  }, {
    label: 'HIPAA',
    to: '/frameworks-and-compliance/hipaa'
  }, {
    label: 'NIST CSF',
    to: '/frameworks-and-compliance/nist-csf'
  }, {
    label: 'PCI DSS',
    to: '/frameworks-and-compliance/pci-dss'
  }, {
    label: 'NIS2',
    to: '/frameworks-and-compliance/nis2'
  }]
}, {
  title: 'Integrations',
  links: [{
    label: 'SIEM',
    to: '/integrations'
  }, {
    label: 'EDR / XDR',
    to: '/integrations'
  }, {
    label: 'Firewalls',
    to: '/integrations'
  }, {
    label: 'Cloud',
    to: '/integrations'
  }, {
    label: 'Identity',
    to: '/integrations'
  }, {
    label: 'Workflow',
    to: '/integrations'
  }, {
    label: 'Supported Technologies',
    to: '/integrations'
  }]
}, {
  title: 'Research & Company',
  links: [{
    label: 'Threat Response Index',
    to: '/research/threat-response-index'
  }, {
    label: 'Picus Labs',
    to: '/research/picus-labs'
  }, {
    label: 'Red Report',
    to: '/research/red-report'
  }, {
    label: 'Blue Report',
    to: '/research/blue-report'
  }, {
    label: 'About',
    to: '/company/about'
  }, {
    label: 'Customers',
    to: '/company/customers'
  }, {
    label: 'Leadership',
    to: '/company/about'
  }, {
    label: 'Partners',
    to: '/company/partners'
  }, {
    label: 'Careers',
    to: '/company/careers'
  }, {
    label: 'Press',
    to: '/company/about'
  }, {
    label: 'Contact',
    to: '/contact'
  }]
}];
export function Footer() {
  return <footer className="bg-picus-surface border-t border-picus-border pt-20 pb-10 mt-24" data-id="element-162">
      <div className="max-w-[1400px] mx-auto px-6" data-id="element-163">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-16" data-id="element-164">
          {footerData.map((col, idx) => <div key={idx} data-id="element-165">
              <h4 className="text-white font-medium mb-6 text-sm tracking-wide" data-id="element-166">
                {col.title}
              </h4>
              <ul className="space-y-3" data-id="element-167">
                {col.links.map((link, linkIdx) => <li key={linkIdx} data-id="element-168">
                    <Link to={link.to} className="text-sm text-picus-muted hover:text-picus-accent transition-colors" data-id="element-169">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="border-t border-picus-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-170">
          <Link to="/" className="flex-shrink-0" data-id="element-171">
            <img src="https://www.picussecurity.com/hubfs/light_logo-original-SVG.svg" alt="Picus Security" className="h-6" data-id="element-172" />
          </Link>
          <div className="flex items-center gap-6 text-sm text-picus-muted" data-id="element-173">
            <span data-id="element-174">&copy; {new Date().getFullYear()} Picus Security</span>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-175">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-176">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}